import React from 'react';

import { TableCellDescriptions } from '../../components/TableCellDescriptions';
import {
  EmergencyScenarioTableFragment,
  EmergencyScenarioTableFragmentDoc,
  getEmergencyScenariosDocument,
  getEmergencyScenariosTotalDocument,
} from '../../graphql/api/generated';
import { useMainApiTableData } from '../../hooks/useTableManager';
import { createdAtColumn, updatedAtAndByColumn } from '../common/columns';
import { getDescriptionsFromColumns } from '../helpers/getDescriptionsFromColumns';
import { IModelTableExpandable } from '../typings';

import * as actions from './actions';
import * as columns from './columns';
import model from './model';

model.actions.setDefaultActions([
  actions.deleteAction,
  actions.toggleStatusAction,
]);

export const expandable: IModelTableExpandable<EmergencyScenarioTableFragment> = {
  rowExpandable: ({ createdAt, updatedAt }) => updatedAt !== createdAt,
  expandedRowRender: (row) => {
    const descriptions = getDescriptionsFromColumns(row, [updatedAtAndByColumn]);

    return <TableCellDescriptions descriptions={descriptions} />;
  },
};

const commonTableConfig = {
  expandable,
  useTableData: useMainApiTableData({
    totalOperation: getEmergencyScenariosTotalDocument,
    listOperation: getEmergencyScenariosDocument,
  }),
  fragment: EmergencyScenarioTableFragmentDoc, // @TODO: Not used, but required by config
};

export const EmergencyScenariosMainTable = model.createTable<EmergencyScenarioTableFragment>({
  ...commonTableConfig,
  columns: [
    columns.propertyColumn,
    columns.nameColumn,
    columns.statusColumn,
    columns.accessPointsColumn,
    columns.createdByColumn,
    createdAtColumn,
  ],
});
